/* eslint-disable prettier/prettier */
import { createSlice } from "@reduxjs/toolkit";

export const usuariosSlice = createSlice({
  name: "dashboard",
  initialState: {
    usuarios: [],
    isloadingUsuarios: false,
    isloadingAdd: false,
    alert: {
      type: "",
      message: "",
      show: false,
    },
  },
  reducers: {
    getusers: (state, action) => {
      state.usuarios = action.payload;
    },
    isLoadingUsers: (state, action) => {
      state.isloadingUsuarios = action.payload;
    },
    isLoadingAddUser: (state, action) => {
      state.isloadingAdd = action.payload;
    },
    setUserAdd: (state, action) => {
      state.usuarios.unshift(action.payload);
      state.alert.type = "success";
      state.alert.message = "Registro de usuario exitoso";
      state.alert.show = true;
    },
    setUserError: (state, action) => {
      state.alert.type = "error";
      state.alert.message = action.payload;
      state.alert.show = true;
    },
    closeAlert: (state, action) => {
      state.alert.type = "";
      state.alert.message = "";
      state.alert.show = false;
    },
    removeUser: (state, action) => {
      const idUsuario = action.payload;
      state.usuarios = state.usuarios.filter((usuario) => usuario.idUsuario !== idUsuario);
    },
    updateUser: (state, action) => {
      const index = state.usuarios.findIndex((u) => u.idUsuario === action.payload.idUsuario);
      if (index !== -1) {
        state.usuarios[index] = action.payload;
      }
      state.alert.type = "success";
      state.alert.message = "Usuario actualizado correctamente";
      state.alert.show = true;
    },
    updateStatusSuccess: (state, action) => {
      const updatedUserData = action.payload; // El usuario actualizado del payload
      state.usuarios = state.usuarios.map((user) =>
        user.idUsuario === updatedUserData.idUsuario ? updatedUserData : user
      );
      state.alert = {
        type: "success",
        message: "Estado del usuario actualizado",
        show: true,
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  getusers,
  setUserAdd,
  isLoadingUsers,
  isLoadingAddUser,
  setUserError,
  closeAlert,
  removeUser,
  updateUser,
  updateStatusSuccess,
} = usuariosSlice.actions;

export default usuariosSlice.reducer;
